import { json } from '@codemirror/lang-json';
import { javascript } from '@codemirror/lang-javascript';
import { python } from '@codemirror/lang-python';
import type { Extension } from '@codemirror/state';

/** Languages supported by {@link codeMirrorLanguageExtensions} for revision files / modules. */
export type CodeModuleLanguage =
    | 'plain'
    | 'json'
    | 'javascript'
    | 'jsx'
    | 'typescript'
    | 'tsx'
    | 'python';

export function codeMirrorLanguageExtensions(language: CodeModuleLanguage): Extension[] {
    switch (language) {
        case 'plain':
            return [];
        case 'json':
            return [json()];
        case 'python':
            return [python()];
        case 'javascript':
            return [javascript()];
        case 'jsx':
            return [javascript({ jsx: true })];
        case 'typescript':
            return [javascript({ typescript: true })];
        case 'tsx':
            return [javascript({ jsx: true, typescript: true })];
    }
}
